module.exports = __webpack_public_path__ + "img/mesa-de-trabajo.fe8d3919.jpg";